module.exports = __webpack_public_path__ + "img/icon-button.d823e25e.svg";